import { exactValidator, genericValidateName, uuidValidator } from './genericName';
import { libHabitat, libInvestor } from './index';
export var prefix = 'investorPolicySupportedIssuedInstruments';
export var nameToID = function (name) {
    validateName(name);
    var parts = name.split('/');
    return {
        habitatID: parts[1],
        investorID: parts[3],
        issuedInstrumentID: parts[5],
    };
};
export var validateName = genericValidateName([
    exactValidator(libHabitat.prefix),
    uuidValidator(),
    exactValidator(libInvestor.prefix),
    uuidValidator(),
    exactValidator(prefix),
    uuidValidator(),
]);
